<ps-ui-modal>
  <ps-ui-modal-title>
    <h5>Quota Title</h5>
  </ps-ui-modal-title>
  <ps-ui-modal-body>
    <div class="rename-quota">
      <input
        class="form-control"
        type="text"
        [(ngModel)]="renamedQuota"
        (keypress)="validateAlphaNumeric($event)"
      />
    </div>
  </ps-ui-modal-body>
  <ps-ui-modal-footer>
    <button
      type="button"
      class="btn btn-primary sbmtBtn"
      (click)="renameQuota()"
    >
      Save Changes
    </button>
    <button type="button" class="clearBtn" psUiButton (click)="close()">
      Cancel
    </button>
  </ps-ui-modal-footer>
</ps-ui-modal>
